class BitmovinNielsenPlugin {
    player;
    currentAd;
    nSdkInstance;
    contentMetadata;
    adPlayHeadPosition = 0;
    contentPlayHeadPosition = 0;
    totalServerSideAdsDuration = 0;
    mediaTailor;
    imaDaiAdManager;
    playHeadTracking=[];

    constructor(options) {
        this.init(options);
    }

    init(options) {
        this.player = options.player;
        this.contentMetadata = options.contentMetadata;
        this.mediaTailor = options?.mediaTailor;
        delete this.contentMetadata.asset_id;
        delete this.contentMetadata.air_date;
        this.initialiseNielsonSdk(options?.apid);
        this.setupEventListeners();

        if (this.mediaTailor) {
            this.setupMediaTailorEvents();
        }

        document.addEventListener('ima-dai-ad-manager-ready', (event) => {
            this.imaDaiAdManager = event.detail;
            this.setupGoogleStitcherEvents()
        })
        this.sendMetadata(this.contentMetadata);
    }

    sendMetadata(metadata) {
        console.log('NIELSEN PLUGIN LOG: Sending metadata');
        console.table(metadata);
        this.nSdkInstance.ggPM('loadMetadata', metadata);
    }

    sendStopPosition() {
        let position = this.contentPlayHeadPosition;
        if (this.currentAd) {
            position = this.adPlayHeadPosition;
        } else if (this.player.isLive()) {
            position = Math.floor(Date.now() / 1000);
        }
        this.nSdkInstance.ggPM("stop", position);
    }

    sendEndPosition(position) {
        console.log(`NIELSEN PLUGIN LOG: Sending end position ${position}`);
        if (this.player.isLive()) {
            position = Math.floor(Date.now() / 1000);
        }
        this.nSdkInstance.ggPM("end", position);
    }

    initialiseNielsonSdk(apId) {
        !function (e, n) {
            function t(e) {
                return "object" == typeof e ? JSON.parse(JSON.stringify(e)) : e
            }

            e[n] = e[n] ||
                {
                    nlsQ: function (o, r, c) {
                        var s = e.document,
                            a = s.createElement("script");
                        a.async = 1,
                            a.src = ("http:" === e.location.protocol ? "http:" : "https:") + "//cdn-gl.nmrodam.com/conf/" + o + ".js#name=" + r + "&ns=" + n;
                        var i = s.getElementsByTagName("script")[0];
                        return i.parentNode.insertBefore(a, i),
                            e[n][r] = e[n][r] || {
                                g: c || {},
                                ggPM: function (o, c, s, a, i) {
                                    e[n][r].q = e[n][r].q || [];
                                    try {
                                        var l = t([o, c, s, a, i]);
                                        e[n][r].q.push(l)
                                    } catch (e) {
                                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.")
                                    }
                                },
                                trackEvent: function (o) {
                                    e[n][r].te = e[n][r].te || [];
                                    try {
                                        var c = t(o);
                                        e[n][r].te.push(c)
                                    } catch (e) {
                                        console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.")
                                    }
                                }
                            },
                            e[n][r]
                    }
                }
        }(window, "NOLBUNDLE");

        this.nSdkInstance = NOLBUNDLE.nlsQ(apId, "nlsnInstance", {nol_sdkDebug: "debug"});
    }

    setupEventListeners() {
        this.player.on(bitmovin.player.PlayerEvent.TimeChanged, (event) => {
            let currentTime = this.player.isLive() ? Math.floor(Date.now() / 1000) : Math.floor(event.time);

            if (this.currentAd) {
                if (this.currentAd?.adElapsedTime) {
                    //Server side advert
                    const currentAdTime = Math.floor(this.currentAd.adElapsedTime);
                    if (this.adPlayHeadPosition !== currentAdTime) {
                        this.adPlayHeadPosition = currentAdTime;
                        this.totalServerSideAdsDuration++;
                        console.warn(`⏱️ Server Side Ad: current time is ${this.adPlayHeadPosition}, SSAI duration: ${this.totalServerSideAdsDuration}`);
                        this.sendPlayHeadPosition();
                    }
                } else {
                    //Client side advert
                    if (this.adPlayHeadPosition !== currentTime) {
                        this.adPlayHeadPosition = currentTime;
                        console.warn(`⏱️ Client Side Ad: current time is ${currentTime}`);
                        this.sendPlayHeadPosition()
                    }
                }
                return;
            }

            currentTime = currentTime - this.totalServerSideAdsDuration;
            if (this.contentPlayHeadPosition !== currentTime || currentTime === 0) {
                this.contentPlayHeadPosition = currentTime;
                console.warn(`⏱️ Content: current time is ${this.contentPlayHeadPosition}, , SSAI duration: ${this.totalServerSideAdsDuration}`);
                this.sendPlayHeadPosition()
            }
        });

        this.player.on(bitmovin.player.PlayerEvent.Paused, this.sendStopPosition.bind(this));

        this.player.on(bitmovin.player.PlayerEvent.AdStarted, this. adStart.bind(this))

        //TODO: Check if seek within unwatched server ad then shift
        this.player.on(bitmovin.player.PlayerEvent.Seek, (event) => {
            this.playHeadTracking=[];
        });

        this.player.on(bitmovin.player.PlayerEvent.AdFinished, this.adEnd.bind(this));

        this.player.on(bitmovin.player.PlayerEvent.AdBreakFinished, (event) => {
            this.sendMetadata(this.contentMetadata);
        });

        this.player.on(bitmovin.player.PlayerEvent.PlaybackFinished, (event) => {
            this.sendEndPosition(this.contentPlayHeadPosition);
        });

        this.player.on(bitmovin.player.PlayerEvent.AdError, this.sendStopPosition.bind(this));
        this.player.on(bitmovin.player.PlayerEvent.AdSkipped, this.sendStopPosition.bind(this));
        this.player.on(bitmovin.player.PlayerEvent.Error, this.sendStopPosition.bind(this));

        this.player.on(bitmovin.player.PlayerEvent.Destroy, this.destroy.bind(this));

        window.addEventListener("destroySsmp", this.destroy.bind(this));

        window.addEventListener("beforeunload", (event) => {
            const urlParams = new URLSearchParams(window.location.search);
            const position = this.currentAd ? this.adPlayHeadPosition : this.contentPlayHeadPosition;
            console.log('BEFORE UNLOAD', position);
            if(this.currentAd){
                this.sendStopPosition(position)
            }else{
                this.sendEndPosition(position)
            }
            if(urlParams.has('nielsen_debug')){
                event.preventDefault();
                event.returnValue = '';
            }
        });
    }

    getAdMetadata(event) {
        let type = 'preroll';
        if (this.contentPlayHeadPosition < Math.floor(this.player.getCurrentTime())) {
            type = 'midroll';
        }
        if (!this.player.isLive() && this.contentPlayHeadPosition >= this.player.getDuration()) {
            type = 'postroll';
        }
        this.getAdIdFromEvent(event);
        return {
            type: type,
            assetid: this.getAdIdFromEvent(event)
        }
    }

    sendPlayHeadPosition() {
        let adId = '';
        let position = this.contentPlayHeadPosition;
        if (this.currentAd) {
            position = this.adPlayHeadPosition;
            adId = this.currentAd.adObject?.adData?.vastAdId ?? this.currentAd.id
        } else if (this.player.isLive()) {
            //TODO: MANAGE TIMESHIFT, for now timeshift is disable at player level
            position = Math.floor(Date.now() / 1000);
        }

        const type = this.currentAd ? `Ad_${adId}` : 'Content';
        const trackId = `${type}_${position}`;

        if(!this.playHeadTracking.includes(trackId)) {
            this.playHeadTracking.push(trackId);
        }else {
            console.log(`NIELSON TRACKING for ${trackId} POSITION ALREADY SENT ${position}`);
            return;
        }

        console.log(`Sending Play Head Position: [Type: ${type}] [position: ${position}]`);
        this.nSdkInstance.ggPM('setPlayheadPosition', Math.floor(position));
    }

    setupMediaTailorEvents() {
        if (!this.mediaTailor?.session) {
            console.error('MediaTailor Session Object Undefined');
        }

        this.mediaTailor.session.addEventListener(this.mediaTailor.mediatailor.SessionUiEvent.AD_START, this.adStart.bind(this));

        this.mediaTailor.session.addEventListener(this.mediaTailor.mediatailor.SessionUiEvent.AD_END, this.adEnd.bind(this));

        this.mediaTailor.session.addEventListener(this.mediaTailor.mediatailor.SessionUiEvent.AD_CLICK, event => {
            if (event.detail.adClickthroughUrl) {
                window.open(event.detail.adClickthroughUrl, "_blank");
                this.mediaTailor.session.onAdClickthrough();
            }
            console.log("NIELSEN PLUGIN LOG: AD_CLICK", event.detail);
        });

        this.mediaTailor.session.addEventListener(this.mediaTailor.mediatailor.SessionUiEvent.AD_PROGRESS, event => {
            this.currentAd = event.detail;
        });
    }

    setupGoogleStitcherEvents() {
        //TODO: Check with Adam if we need to track this
        this.imaDaiAdManager.addEventListener(google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, (e) => {

        })

        this.imaDaiAdManager.addEventListener(google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, (e) => {

        })
    }

    adStart(event) {
        this.adPlayHeadPosition = 0;
        this.currentAd = event.detail ?? event.ad;
        console.log("NIELSEN PLUGIN LOG: adStart: ", this.currentAd);
        this.sendMetadata(this.getAdMetadata(event));
        this.sendPlayHeadPosition();
    }

    adEnd(event) {
        let lastAdInPod = false;
        console.log(`NIELSEN PLUGIN LOG: Ad playback completed [Position: ${this.adPlayHeadPosition}]`);
        this.sendStopPosition();
        //Check if last ad in pod
        if(this.currentAd?.adObject?.adData){
            if(this.currentAd.adObject.adData.availAdCount === (this.currentAd.adObject.adData.availAdIndex + 1)){
                console.warn(`NIELSEN PLUGIN LOG: Last Ad in Pod [ID: ${this.getAdIdFromEvent(event)}]`);
                lastAdInPod = true;
            }else{
                console.warn(`NIELSEN PLUGIN LOG: Not Last Ad in Pod [ID: ${this.getAdIdFromEvent(event)}]`);
            }
        }

        if(lastAdInPod){
            this.sendMetadata(this.contentMetadata);
        }
        this.currentAd = null;
    }

    getAdIdFromEvent(event) {
        return event?.detail?.adObject?.adData?.vastAdId ?? event.ad.id;
    }

    destroy(){
        const position = this.currentAd ? this.adPlayHeadPosition : this.contentPlayHeadPosition;
        if(this.currentAd){
            this.sendStopPosition(position)
        }else{
            this.sendEndPosition(position)
        }
        this.nSdkInstance = null;
    }
}

export default BitmovinNielsenPlugin;